import NavBar from "../../components/NavBar/NavBar";
import logo from "../../assets/oq-logo.png";
import "./CompleteSignUpPage.scss";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosClient from "../../axiosClient";

/**
 * Stripe redirect return URL for signup.
 * Confirms payment with the backend and only then issues access tokens.
 */
export default function CompleteSignUpPage() {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCompleting, setIsCompleting] = useState(true);

  useEffect(() => {
    const paymentIntentId = searchParams.get("payment_intent");
    const setupIntentId = searchParams.get("setup_intent");
    const redirectStatus = searchParams.get("redirect_status");

    if (!paymentIntentId && !setupIntentId) {
      window.location.replace("/sign-up");
      return;
    }

    if (redirectStatus && redirectStatus !== "succeeded") {
      setIsCompleting(false);
      setErrorMessage(
        "Payment was not completed. Please try again or contact ophthalmologyq@gmail.com for support.",
      );
      return;
    }

    const complete = async () => {
      try {
        const body: { paymentIntentId?: string; setupIntentId?: string } = {};
        if (paymentIntentId) body.paymentIntentId = paymentIntentId;
        if (setupIntentId) body.setupIntentId = setupIntentId;

        const response = await axiosClient.post(
          "/payments/oq-complete-subscription",
          body,
        );
        const { accessToken } = response.data;
        if (accessToken) {
          sessionStorage.setItem("accessTokenOq", accessToken);
          window.location.replace("/dashboard");
          return;
        }
        if (sessionStorage.getItem("accessTokenOq")) {
          window.location.replace("/dashboard");
          return;
        }
        window.location.replace(
          `${process.env.REACT_APP_SITE_URL}/login`,
        );
      } catch (err: any) {
        console.error(err);
        setIsCompleting(false);
        setErrorMessage(
          err?.response?.data?.error ||
            "Could not finish signup. Please contact ophthalmologyq@gmail.com for support.",
        );
      }
    };

    complete();
  }, [searchParams]);

  return (
    <>
      <NavBar />
      <div id="CompleteSignUpPage">
        <div className="site-container">
          <div className="order-summary-wrapper">
            <div className="order-summary-inner">
              <div className="big-logo-wrapper">
                <img src={logo} className="big-logo" alt="" />
              </div>

              <div className="inner-wrapper">
                {isCompleting && !errorMessage && (
                  <>
                    <h1>Confirming payment…</h1>
                    <p>Please wait while we finish setting up your account.</p>
                  </>
                )}
                {errorMessage && (
                  <>
                    <h1>Signup incomplete</h1>
                    <p style={{ color: "red" }}>{errorMessage}</p>
                    <p>
                      <a href="/sign-up">Return to signup</a>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
